import { render } from "./Cockpit.vue?vue&type=template&id=782b7a1f&scoped=true"
import script from "./Cockpit.vue?vue&type=script&lang=js"
export * from "./Cockpit.vue?vue&type=script&lang=js"

import "./Cockpit.vue?vue&type=style&index=0&id=782b7a1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782b7a1f"]])

export default __exports__